// extracted by mini-css-extract-plugin
export default {"root":"dSgz6B","line":"d9ucOd"};